import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

type HeadingLevel = 'display' | 'title' | 'title-sm'

interface SectionHeadingProps {
  eyebrow?: string
  title: ReactNode
  description?: ReactNode
  align?: 'left' | 'center'
  level?: HeadingLevel
  as?: 'h1' | 'h2' | 'h3'
  className?: string
}

const titleClass: Record<HeadingLevel, string> = {
  display: 'eh-display',
  title: 'eh-title',
  'title-sm': 'eh-title-sm',
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  level = 'title',
  as = 'h2',
  className,
}: SectionHeadingProps) {
  const Tag = as

  return (
    <div
      className={cn(
        'section-heading max-w-[700px]',
        align === 'center' && 'mx-auto text-center',
        className,
      )}
    >
      {eyebrow ? <p className="eh-eyebrow">{eyebrow}</p> : null}
      <Tag className={titleClass[level]}>{title}</Tag>
      {description ? (
        <p
          className={cn(
            'mt-5 max-w-[550px] text-base leading-relaxed text-eh-muted',
            align === 'center' && 'mx-auto',
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
  )
}

export default SectionHeading
